<template>
  <v-footer app absolute dark>
    <v-row class="footer-content" justify="center" align="center">
      <v-col cols="12" md="3">
        <div class="title">© Copyright {{ year }}</div>
        <div>
          KANCELARIA RADCY PRAWNEGO<br />
          DAMIAN MICHALAK
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <div class="title">
          KONTAKT
        </div>
        <div class="footer-icons">
          <div><v-icon>location_on</v-icon> Ul. Piękna 24/26A Warszawa</div>
          <div><v-icon>email</v-icon> biuro@dmkancelaria.pl</div>
          <div><v-icon>local_phone</v-icon> 660 337 223</div>
          <div>
            <v-icon>thumb_up</v-icon>&nbsp;
            <a href="https://pwmgroup.pl">
              <span>Created by PWM Group</span>
            </a>
          </div>
        </div>
      </v-col>
      <!-- <v-col cols="12" md="3">
        <div class="title">
          Nota prawna
        </div>
        <div class="footer-long-text body-2">
          Podanie adresu e-mail jest dobrowolne, ale niezbędne do korzystania z Newslettera. Przysługuje mi prawo dostępu do treści moich danych osobowych oraz ich poprawiania. Administratorem danych osobowych jest Kancelaria Radcy Prawnego Damian Michalak (adres biura: ul. Piękna 24/26a, 00-549 Warszawa, NIP: 8381765174). Dane osobowe zawarte w formularzu będą przetwarzane w celu realizacji usługi Newsletter oraz w celach marketingowych.
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <div class="title">
          Newsletter
        </div>
        <div>
          Zapraszamy do subskrypcji naszego newslettera.
        </div>
        <div>
          <v-text-field
            color="accent-light"
            prepend-icon="email"
            label="Twój adres email"
          >
          </v-text-field>
          <v-btn color="accent">
            Wyślij
          </v-btn>
        </div>
      </v-col> -->
    </v-row>
  </v-footer>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Footer',
  data() {
    return {
      year: moment().year(),
    };
  },
};
</script>

<style scoped>
.footer-content {
  vertical-align: middle;
}
.footer-icons div {
  vertical-align: middle;
}
.footer-content .footer-long-text {
  font-family: 'Source Sans Pro', sans-serif !important;
}
</style>
